import checkbox from './checkbox';
import datePicker from './datePicker';
import frame from './frame';
import hidden from './hidden';
import input from './input';
import radio from './radio';
import select from './select';
import slider from './slider';
import iswitch from './switch';
import timePicker from './timePicker';
import tree from './tree';
import upload from './upload';

export default [
    checkbox,
    datePicker,
    frame,
    hidden,
    input,
    radio,
    select,
    slider,
    iswitch,
    timePicker,
    tree,
    upload
]